var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRealtimeReporting = function SvgRealtimeReporting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 69.84,
    y1: 194.49,
    x2: 206.94,
    y2: 43.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 65.33,
    y1: 190.39,
    x2: 202.44,
    y2: 39.5,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 112.25,
    y1: 233.02,
    x2: 249.35,
    y2: 82.12,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 30.08,
    y1: 158.36,
    x2: 167.19,
    y2: 7.47,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 4.64,
    y1: 135.25,
    x2: 141.75,
    y2: -15.65,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 16.06,
    y1: 145.62,
    x2: 153.16,
    y2: -5.28,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 56.37,
    y1: 182.25,
    x2: 193.48,
    y2: 31.35,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 81.43,
    y1: 205.02,
    x2: 218.54,
    y2: 54.13,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 4.73,
    y1: 135.32,
    x2: 141.83,
    y2: -15.57,
    xlinkHref: "#b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M138.49,164.81c.1-1.17.22-2.34.22-3.52,0-21.38-17.33-38.71-38.71-38.71s-38.71,17.33-38.71,38.71c0,21.38,17.33,38.71,38.71,38.71,11.01,0,21.51-4.69,28.85-12.9l-4.81-4.3c-11.88,13.28-32.27,14.42-45.55,2.54s-14.42-32.27-2.54-45.55,32.27-14.42,45.55-2.54c6.84,6.12,10.75,14.86,10.75,24.04,0,1-.1,1.99-.19,2.98l-3.68-4.91-5.16,3.87,9.68,12.9c1.07,1.43,3.09,1.71,4.52.65.24-.18.46-.4.65-.65l9.68-12.9-5.16-3.87-4.09,5.45Z",
    style: {
      fill: "url(#b)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.77,162.52l-11.12,5.56,2.88,5.77,12.9-6.45c1.09-.55,1.78-1.66,1.78-2.89v-25.81h-6.45v23.81Z",
    style: {
      fill: "url(#c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.84,
    y: 158.07,
    width: 45.16,
    height: 6.45,
    style: {
      fill: "url(#d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 158.07,
    width: 54.84,
    height: 6.45,
    style: {
      fill: "url(#e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.71,151.61v-70.97c0-1.78-1.44-3.23-3.23-3.23H9.68c-1.78,0-3.23,1.44-3.23,3.23v70.97h6.45v-67.74h19.35v67.74h6.45Z",
    style: {
      fill: "url(#f)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.52,51.61h19.35v64.52h6.45V48.39c0-1.78-1.44-3.23-3.23-3.23h-25.81c-1.78,0-3.23,1.44-3.23,3.23v83.87h6.45V51.61Z",
    style: {
      fill: "url(#g)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.94,132.26v-51.61c0-1.78-1.44-3.23-3.23-3.23h-25.81c-1.78,0-3.23,1.44-3.23,3.23v35.48h6.45v-32.26h19.35v48.39h6.45Z",
    style: {
      fill: "url(#h)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.52,45.16c-1.78,0-3.23,1.44-3.23,3.23v103.23h6.45V51.61h19.35v100h6.45V48.39c0-1.78-1.44-3.23-3.23-3.23h-25.81Z",
    style: {
      fill: "url(#i)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.32,64.57c7.14,0,12.94-5.77,12.95-12.92,0-1.7-.33-3.38-.98-4.96l31.68-23.76c5.1,4.15,12.52,3.75,17.14-.93l33.34,19.64c-.35,1.14-.53,2.32-.55,3.52,0,7.13,5.78,12.9,12.9,12.9s12.9-5.78,12.9-12.9c-.01-1.32-.23-2.62-.65-3.87l30.5-19.03c2.39,2.28,5.55,3.55,8.85,3.55,7.13,0,12.9-5.78,12.9-12.9S184.55,0,177.42,0s-12.9,5.78-12.9,12.9c.01,1.32.23,2.62.65,3.87l-30.5,19.03c-5.06-4.84-13.06-4.73-17.98.24l-33.35-19.62c.35-1.14.53-2.32.55-3.52C83.87,5.78,78.09,0,70.96,0c-7.13,0-12.9,5.78-12.9,12.91,0,1.68.33,3.34.97,4.9l-31.67,23.76c-2.26-1.84-5.09-2.85-8.01-2.86-7.14,0-12.94,5.77-12.95,12.92,0,7.14,5.77,12.94,12.92,12.95ZM177.42,6.45c3.56,0,6.45,2.89,6.45,6.45s-2.89,6.45-6.45,6.45-6.45-2.89-6.45-6.45,2.89-6.45,6.45-6.45ZM125.81,38.71c3.56,0,6.45,2.89,6.45,6.45s-2.89,6.45-6.45,6.45-6.45-2.89-6.45-6.45,2.89-6.45,6.45-6.45ZM70.97,6.45c3.56,0,6.45,2.89,6.45,6.45s-2.89,6.45-6.45,6.45-6.45-2.89-6.45-6.45,2.89-6.45,6.45-6.45ZM19.35,45.16c3.56,0,6.45,2.89,6.45,6.45s-2.89,6.45-6.45,6.45-6.45-2.89-6.45-6.45,2.89-6.45,6.45-6.45Z",
    style: {
      fill: "url(#j)",
      strokeWidth: 0
    }
  }));
};
export default SvgRealtimeReporting;